import { render } from "./WidgetBlock1.vue?vue&type=template&id=6cce2d0d"
import script from "./WidgetBlock1.vue?vue&type=script&lang=js"
export * from "./WidgetBlock1.vue?vue&type=script&lang=js"

import exportComponent from "D:\\working\\MyCi4Vue\\myCi4Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__